function installmentCountFromName(name) {
  if (!name || !/installment/i.test(name)) return null;

  for (const word of name.trim().split(/\s+/)) {
    const cleaned = word.replace(/[×x]/gi, "");
    if (!/^\d+$/.test(cleaned)) continue;

    const count = Number.parseInt(cleaned, 10);
    if (count > 1) return count;
  }

  return null;
}

function installmentCountFromVariant(variant) {
  if (!variant) return null;

  const labels = [variant.title, ...(variant.options || [])];
  for (const label of labels) {
    const count = installmentCountFromName(label);
    if (count) return count;
  }

  return null;
}

class InstallmentMultiplier extends HTMLElement {
  connectedCallback() {
    this.form = document.forms[this.getAttribute("form")];
    this.onVariantChanged = (event) => {
      const count = installmentCountFromVariant(event.detail?.variant);
      this.hidden = !count;
      this.textContent = count ? `×${count}` : "";
    };
    this.form?.addEventListener("variant:change", this.onVariantChanged);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.onVariantChanged);
  }
}

if (!window.customElements.get("installment-multiplier")) {
  window.customElements.define("installment-multiplier", InstallmentMultiplier);
}

function installmentMoney(cents) {
  const value = Number(cents);
  if (!Number.isFinite(value)) return "";

  const amount = (value / 100).toFixed(2).replace(/\.00$/, "");
  const format = window.themeVariables?.settings?.moneyFormat || "${{amount}}";
  return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
}

function fullTicketPrice(variant, product) {
  const variants = product?.variants || [];
  const full = variants.find((item) => item && item.id !== variant?.id && !installmentCountFromVariant(item));
  return full?.price ?? null;
}

class InstallmentNote extends HTMLElement {
  connectedCallback() {
    this.form = document.forms[this.getAttribute("form")];
    this.onVariantChanged = (event) => {
      this.renderNote(event.detail?.variant, event.detail?.product);
    };
    this.form?.addEventListener("variant:change", this.onVariantChanged);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.onVariantChanged);
  }

  renderNote(variant, product) {
    const count = installmentCountFromVariant(variant);
    const fullPrice = fullTicketPrice(variant, product) ?? Number(this.getAttribute("full-price"));

    if (!count || !variant || !fullPrice) {
      this.hidden = true;
      return;
    }

    const remaining = count - 1;
    const paymentWord = remaining === 1 ? "payment" : "payments";
    this.hidden = false;
    this.innerHTML = `<p class="installment-note__title">Interest-free installments</p><p>Pay for your ${installmentMoney(fullPrice)} ticket in ${count} easy monthly installments of ${installmentMoney(variant.price)}. Your first payment is due at checkout, with the remaining ${remaining} ${paymentWord} automatically billed each month.</p>`;
  }
}

if (!window.customElements.get("installment-note")) {
  window.customElements.define("installment-note", InstallmentNote);
}
